import { createTheme } from "@material-ui/core/styles";
import Typography from "jb_component_library/theme/JBTheme/Typography";
import Colors from "./Colours";

declare module "@material-ui/core/styles/createBreakpoints" {
	interface BreakpointOverrides {
		xs: true;
		sm: true;
		md: true;
		lg: true;
		xl: true;
		xxl: true;
	}
}
declare module "@material-ui/core/styles/createPalette" {
	export interface Palette {
		border: PaletteColor;
	}

	export interface PaletteColor {
		neutral: string;
	}
}

export const ThemeConfig = {
	themeName: "Group",
	palette: Colors,
	spacing: (factor: number): string => `${0.25 * factor}rem`,
	breakpoints: {
		values: {
			xs: 0,
			sm: 576,
			md: 768,
			lg: 992,
			xl: 1400,
			xxl: 1920,
		},
	},
	typography: Typography,
	overrides: {
		MuiSvgIcon: {
			root: {
				color: Colors.primary.main
			}
		},
		MuiTypography: {
			root: {
				marginBottom: 8
			}
		},
	}
};
const Theme = createTheme(ThemeConfig);
export default Theme;
